import React from 'react';
import {
  FIELD_CATEGORY,
  CUSTOM_FIELDS_TYPE,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  Loader,
  getNotificationTemplateByConstantHook
} from '@nile/components';
import {
  Button,
  Modal,
  Checkbox,
  Banner,
  ButtonGroup,
  TextStyle
} from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import ClosureFields from './ClosureFields';
import { filter, forEach, isEmpty } from 'lodash';

class ClosureModal extends React.PureComponent {
  constructor(props) {
    super(props);
    const closeTicketClicked = sessionStorage.getItem('closeTicketClicked');
    const suppressCloseNotificationClicked = sessionStorage.getItem(
      'suppressCloseNotificationClicked'
    );
    this.state = {
      updatedFields: null,
      isSaveDisabled: true,
      closeNotification: !!suppressCloseNotificationClicked,
      showSuppressCloseNotification:
        closeTicketClicked || suppressCloseNotificationClicked
    };
    this.updateFields = this.updateFields.bind(this);
    this.saveAction = this.saveAction.bind(this);
    this.checkIsSaveDisabled = this.checkIsSaveDisabled.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      updatedFields: this.props.errorsOnClosure?.fields
    });
  }

  // eslint-disable-next-line react/sort-comp
  saveAction() {
    const ticket = this.props.errorsOnClosure?.ticket;
    const status = this.props.errorsOnClosure?.status
      ? { status: this.props.errorsOnClosure?.status }
      : {};
    const updatedFields = { ...this.state.updatedFields };

    let defaultFields = {};
    let customFields = {};

    const keys = Object.keys(this.state.updatedFields);
    const defaultFieldKeys = Object.values(DEFAULT_FIELDS_BY_COLUMN_NAME);

    keys.forEach((key) => {
      if (defaultFieldKeys.includes(key)) {
        defaultFields = { ...defaultFields, [key]: updatedFields[key] };
      } else {
        customFields = { ...customFields, [key]: updatedFields[key] };
      }
    });

    const fieldsForResponse = {
      ...status,
      ...defaultFields,
      customFields
    };
    if (this.state?.closeNotification) {
      fieldsForResponse.suppressCloseNotification = this.state.closeNotification;
    }
    if (this.props.onSave) {
      this.props.onSave(ticket, fieldsForResponse);
    }
  }

  closeModal() {
    this.props.setModalActive(false);
    this.props.setErrorsOnClosure(null);
    this.setState({
      updatedFields: null
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  checkIsSaveDisabled() {
    const validationObject = { ...this.state.updatedFields };

    const valueArray = validationObject && Object.values(validationObject);

    const validationArray = valueArray && valueArray.flatMap((el) => !!el);
    const enableSave = validationArray.filter((el) => !el).length === 0;
    this.setState({ isSaveDisabled: !enableSave });
  }

  updateAllFields = (fields) => {
    this.setState({
      allFormFields: fields
    });
  };

  setFieldValue = (field, value) => {
    const { fieldCategory, columnName, fieldType } = field;
    let updatedData = {};
    if (fieldCategory === FIELD_CATEGORY.DEFAULT) {
      updatedData = {
        ...updatedData,
        [columnName]: value?.value
      };
    }
    if (fieldCategory === FIELD_CATEGORY.CUSTOM) {
      if (fieldType === CUSTOM_FIELDS_TYPE.SELECT) {
        updatedData = {
          ...updatedData,
          [columnName]: value?.value
        };
      } else if (fieldType === CUSTOM_FIELDS_TYPE.MULTI_SELECT) {
        const val = value.map((el) => el?.value);
        updatedData = { ...updatedData, [columnName]: val };
      } else if (fieldType === CUSTOM_FIELDS_TYPE.CHECKBOX) {
        let updatedValue = updatedData[columnName];
        if (value?.value) {
          updatedValue = updatedValue
            ? [...updatedValue, value?.label]
            : [value?.label];
        } else {
          updatedValue = updatedValue.filter((el) => el !== value?.label);
        }
        updatedData = {
          ...updatedData,
          [columnName]: updatedValue
        };
      } else if (fieldType === CUSTOM_FIELDS_TYPE.RADIO) {
        let updatedValue = updatedData[columnName];
        if (value?.value) {
          updatedValue = value?.label;
        }
        updatedData = {
          ...updatedData,
          [columnName]: updatedValue
        };
      } else {
        updatedData = {
          ...updatedData,
          [columnName]: value
        };
      }
    }
    return updatedData;
  };

  getChilds = (field) => {
    const { allFormFields } = this.state;
    const result = [];
    function findChildren(parentColumnName) {
      if (!parentColumnName) return;
      const children = filter(
        allFormFields,
        (field) => field?.parentField?.columnName === parentColumnName
      );
      result.push(...children);
      forEach(children, (child) => findChildren(child?.columnName));
    }
    findChildren(field?.columnName);
    return result;
  };

  updateFields(field, value) {
    let updatedFormFields = this.state.updatedFields;
    let fldValue = this.setFieldValue(field, value, updatedFormFields);
    updatedFormFields = { ...updatedFormFields, ...fldValue };
    const childs = this.getChilds(field);
    if (!isEmpty(childs)) {
      let flds = updatedFormFields;
      childs?.map((el) => {
        flds = this.setFieldValue(el, null, flds);
        updatedFormFields = { ...updatedFormFields, ...flds };
      });
    }
    this.setState({ updatedFields: updatedFormFields });
  }

  componentDidUpdate() {
    this.checkIsSaveDisabled();
  }

  onChangeHandler(val) {
    this.setState((prevState) => ({
      ...prevState,
      closeNotification: val
    }));
  }

  render() {
    const showSuppressCloseNotificationCheckbox =
      this.state.showSuppressCloseNotification &&
      this.props?.isOncloseNotificationEnabled;
    return (
      <>
        <Modal
          open={this.props.modalActive}
          onClose={this.closeModal}
          title={
            <FormattedMessage
              id={this.props.title || 'ticket.closure.modal.title'}
            />
          }
          footer={
            <div
              className={`flex save-btn ${
                showSuppressCloseNotificationCheckbox ? 'jspbtwn actr' : 'jend'
              }`}
            >
              {showSuppressCloseNotificationCheckbox && (
                <Checkbox
                  label={
                    <span className="fx actr g5">
                      <SVGIcon name="NotificationsBellCrossed" />
                      <FormattedMessage id="ticket.close.notification.message" />
                    </span>
                  }
                  onChange={this.onChangeHandler.bind(this)}
                  checked={this.state?.closeNotification}
                />
              )}
              <ButtonGroup>
                {this.props.showCancelBtn && (
                  <Button plainSecondary onClick={this.closeModal}>
                    <FormattedMessage id="common.cancel" />
                  </Button>
                )}
                <Button
                  primary
                  disabled={this.state.isSaveDisabled}
                  onClick={this.saveAction}
                  loading={this.props.saveLoading}
                >
                  <FormattedMessage id="common.save" />
                </Button>
              </ButtonGroup>
            </div>
          }
        >
          <Modal.Section>
            <div className="content-wrapper">
              {this.props.infoBannerKey && (
                <div className="tw-mb-4">
                  <Banner status="info">
                    <TextStyle weight="medium">
                      <FormattedMessage id={this.props.infoBannerKey} />
                    </TextStyle>
                  </Banner>
                </div>
              )}
              <div className="content">
                {this.state.updatedFields && (
                  <>
                    <ClosureFields
                      fields={this.state.updatedFields}
                      onChange={this.updateFields}
                      ticket={this.props.errorsOnClosure?.ticket}
                      updateAllFields={this.updateAllFields}
                    />
                  </>
                )}
              </div>
            </div>
          </Modal.Section>
        </Modal>
      </>
    );
  }
}

function closureModalWithNotificationTemplateData(props) {
  const notificationTemplateByConstant = getNotificationTemplateByConstantHook({
    notificationTemplateType: 'SYSTEM_TICKETING',
    constant: 'TICKET_REQ_CLOSED'
  });
  return (
    <ClosureModal
      {...props}
      isOncloseNotificationEnabled={notificationTemplateByConstant?.activated}
    />
  );
}

export default closureModalWithNotificationTemplateData;
